<template>
  <Teleport to="body">
    <Transition
      enter-from-class="scale-x-150 opacity-0"
      leave-to-class="scale-x-150 opacity-0"
      enter-active-class="transition duration-300"
      leave-active-class="transition duration-300"
    >
      <!-- Mask -->
      <div
        v-if="modelValue"
        ref="mask"
        class="fixed top-0 left-0 z-50 h-full w-full bg-black/20 dark:bg-white/30 transition-all"
        tabindex="0"
      >
        <!-- Wrapper -->
        <div class="modal-wrapper">
          <!-- Container -->
          <div
            ref="container"
            class="fixed flex h-full flex-col bg-neutral-50 dark:bg-neutral-800 shadow-[0_6px_20px_rgba(0,_0,_0,_0.2)] max-w-full"
            :class="{ 'right-0': direction === 'rtl', 'left-0': direction === 'ltr' }"
            :style="{ width: typeof width === 'string' ? width : `${width}px` }"
          >
            <!-- <UseFocusTrap v-if="modelValue"> -->
            <div class="mx-4 my-4 flex items-center">
              <slot name="title">
                <div class="text-neutral-800 dark:text-neutral-300">{{ title }}</div>
              </slot>
              <div class="grow" />
              <button
                class="inline-flex h-8 w-8 cursor-pointer items-center justify-center rounded-full border-0 bg-transparent text-neutral-400 transition-all hover:text-neutral-500"
                @click="close()"
              >
                <UiIcon :size="32" icon="x" />
              </button>
            </div>
            <div class="grow overflow-auto px-6">
              <slot />
            </div>
            <!-- </UseFocusTrap> -->
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { onKeyStroke, useFocusWithin } from '@vueuse/core'
import UiIcon from '@/components/ui/icon.vue'

const props = withDefaults(
  defineProps<{
    title?: string
    modelValue: boolean
    direction?: string
    width?: string | number
    closeOnClickOut?: boolean
    closeOnEsc?: boolean
    beforeClose?: () => boolean
  }>(),
  {
    direction: 'rtl',
    width: '25%',
    closeOnClickOut: true,
    closeOnEsc: true,
    beforeClose: () => true
  }
)

const mask = ref<HTMLDivElement>()
const container = ref<HTMLDivElement>()
const { focused } = useFocusWithin(mask)

const emit = defineEmits(['update:modelValue'])
const close = () => {
  if (typeof props.beforeClose === 'function' && props.beforeClose() === false) return

  emit('update:modelValue', false)
}

onKeyStroke('Escape', () => focused.value && props.closeOnEsc && close())
</script>
